import ViewArticleHighlights from '../implementations/View/ArticleHighlights';
import ViewArticleOverview from '../implementations/View/ArticleOverview';
import ViewArticleRelated from '../implementations/View/ArticleRelated';
import ViewArticlesFiltered from '../implementations/View/ArticlesFiltered';
import ViewDocsByTheme from '../implementations/View/DocsByTheme';
import ViewEventsFiltered from '../implementations/View/EventsFiltered';
import ViewEventsUpcoming from '../implementations/View/EventsUpcoming';
import ViewMediaFiltered from '../implementations/View/MediaFiltered';
import ViewMediaPersonsFiltered from '../implementations/View/PersonsFiltered';
import ViewPartnersHighlights from '../implementations/View/PartnersHighlights';
import ViewPartnersOverview from '../implementations/View/PartnersOverview';
import ViewProjectsFiltered from '../implementations/View/ProjectsFiltered';
import ViewProjectTypesOverview from '../implementations/View/ProjectTypesOverview';
import ViewThemesOverview from '../implementations/View/ThemesOverview';
import ViewVacanciesOverview from '../implementations/View/VacanciesOverview';
import ViewProjectsRelated from '../implementations/View/ProjectRelated';

const mappers = {
  views_block__article_highlights: ViewArticleHighlights,
  views_block__article_overview: ViewArticleOverview,
  views_block__article_related: ViewArticleRelated,
  views_block__articles_filtered_articles_filtered: ViewArticlesFiltered,
  views_block__docs_by_theme: ViewDocsByTheme,
  views_block__events_filtered_events_filtered: ViewEventsFiltered,
  views_block__events_upcoming: ViewEventsUpcoming,
  views_block__media_filtered_media_filtered: ViewMediaFiltered,
  views_block__partners_highlights: ViewPartnersHighlights,
  views_block__partners_overview: ViewPartnersOverview,
  views_block__persons_filtered_persons_filtered: ViewMediaPersonsFiltered,
  views_block__project_types_default: ViewProjectTypesOverview,
  views_block__projects_filtered_highlighted: ViewProjectsFiltered,
  views_block__projects_filtered_related: ViewProjectsRelated,
  views_block__projects_filtered_projects_filtered: ViewProjectsFiltered,
  views_block__vacancies_default: ViewVacanciesOverview,
  views_block__themes_filtered_parent_theme: ViewThemesOverview,
};

export default mappers;
